import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeaderProps {
  eyebrow: string;
  title: React.ReactNode;
  description?: string;
  align?: 'left' | 'center';
  className?: string;
}
export function SectionHeader({
  eyebrow,
  title,
  description,
  align = 'center',
  className = ''
}: SectionHeaderProps) {
  const alignmentClass = align === 'center' ? 'text-center mx-auto' : 'text-left';
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6
  }} className={`${alignmentClass} ${className}`} data-id="element-409">
      <p className="text-[11px] tracking-[3px] uppercase text-gold mb-3" data-id="element-410">
        {eyebrow}
      </p>

      <div className={`w-[60px] h-[2px] bg-gradient-to-r from-gold to-gold-light mb-6 ${align === 'center' ? 'mx-auto' : ''}`} data-id="element-411" />

      <h2 className="font-display text-[clamp(28px,4vw,44px)] font-black leading-[1.2] mb-4 text-white" data-id="element-412">
        {title}
      </h2>

      {description && <p className="text-[17px] text-gray leading-[1.7] max-w-[620px] mx-auto mb-[60px]" data-id="element-413">
          {description}
        </p>}
    </motion.div>;
}